(function(){
  if(window.__hmAv) return; window.__hmAv=true;
  // Retour arrière : fiche restaurée depuis le cache -> rechargée (bouton jamais grisé)
  window.addEventListener('pageshow',function(e){if(e.persisted&&document.querySelector('[data-av-product]'))location.reload();});
  var $=function(s,r){return (r||document).querySelector(s)}, $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';

  // Libellé de l'option « Univers », identique aux variantes : « Ferme », « 2 Ferme », « 2 Ferme + 1 Chantier »…
  function uniLabel(n,f,A,B){var c=n-f;if(n===1)return f?A:B;if(!c)return n+' '+A;if(!f)return n+' '+B;return f+' '+A+' + '+c+' '+B;}

  function product(el){
    var data=JSON.parse(($('[data-av-variants]',el)||$('[data-av-variants]',el.parentNode)).textContent);
    var A=el.getAttribute('data-uni-a'), B=el.getAttribute('data-uni-b');
    var packs=$$('[data-av-pack]',el), form=$('[data-av-form]',el), idInput=$('[data-av-id]',el);
    var tr=$('[data-av-track]',el), slides=$$('[data-av-slide]',el), thumbs=$$('[data-av-thumb]',el);
    var hasUni=data.some(function(v){return v.o2!==null&&v.o2!==undefined});
    var current=null;

    function idx(){var best=0,bd=1e9;slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-tr.scrollLeft);if(d<bd){bd=d;best=i;}});return best;}
    function go(i,now){if(!slides[i])return;tr.scrollTo({left:slides[i].offsetLeft,behavior:now?'auto':'smooth'});}
    function mark(){var i=idx();thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===i?'true':'false');});}
    if(tr){tr.addEventListener('scroll',function(){clearTimeout(tr.__t);tr.__t=setTimeout(mark,60);},{passive:true});}
    thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)});});

    function active(){return packs.filter(function(p){return p.getAttribute('aria-checked')==='true'})[0]||packs[0];}
    function slotsOf(p){return $$('[data-av-slot]',p);}
    function slotVal(s){var b=$('[data-av-chip][aria-pressed="true"]',s);return b?b.getAttribute('data-av-chip'):'a';}
    function setSlot(s,v){$$('[data-av-chip]',s).forEach(function(b){b.setAttribute('aria-pressed',b.getAttribute('data-av-chip')===v?'true':'false')});}

    function variantFor(p){
      var pack=p.getAttribute('data-pack');
      if(!hasUni) return data.filter(function(v){return v.o1===pack})[0];
      var n=+p.getAttribute('data-n'), f=slotsOf(p).filter(function(s){return slotVal(s)==='a'}).length;
      var o2=uniLabel(n,f,A,B);
      return data.filter(function(v){return v.o1===pack&&v.o2===o2})[0];
    }

    function update(jump){
      var p=active(); current=variantFor(p);
      $('[data-av-price]',el).textContent=p.getAttribute('data-price');
      var cmp=$('[data-av-compare]',el), pct=$('[data-av-pct]',el), c=p.getAttribute('data-compare');
      if(cmp){cmp.textContent=c;cmp.hidden=!c;}
      if(pct){pct.textContent='−'+p.getAttribute('data-pct')+' %';pct.hidden=!c;}
      $('[data-av-atc-price]',el).textContent=p.getAttribute('data-price');
      if(current){
        idInput.value=current.id;
        if(jump&&current.m){slides.forEach(function(s,i){if(+s.getAttribute('data-media')===current.m)go(i,jump==='now')});}
      }
    }

    function select(p){
      var prev=active();
      if(prev===p) return;
      // Les nouveaux calendriers reprennent l'univers du calendrier n°1
      var first=prev?slotVal(slotsOf(prev)[0]||document.createElement('i')):'a';
      packs.forEach(function(q){q.setAttribute('aria-checked',q===p?'true':'false')});
      var mine=slotsOf(p), old=prev?slotsOf(prev):[];
      mine.forEach(function(s,i){setSlot(s,old[i]?slotVal(old[i]):first);});
      update(true);
    }

    packs.forEach(function(p){
      p.addEventListener('click',function(e){
        var chip=e.target.closest('[data-av-chip]');
        if(chip){select(p);setSlot(chip.closest('[data-av-slot]'),chip.getAttribute('data-av-chip'));update(true);return;}
        select(p);
      });
      p.addEventListener('keydown',function(e){
        if(e.target!==p)return;
        if(e.key==='Enter'||e.key===' '){e.preventDefault();select(p);}
        if(e.key==='ArrowDown'||e.key==='ArrowRight'||e.key==='ArrowUp'||e.key==='ArrowLeft'){
          e.preventDefault();var i=packs.indexOf(p)+((e.key==='ArrowDown'||e.key==='ArrowRight')?1:-1);
          var q=packs[(i+packs.length)%packs.length];select(q);q.focus();
        }
      });
    });

    // État initial : variante de l'URL (?variant=) ou première variante
    var init=+el.getAttribute('data-initial'), iv=data.filter(function(v){return v.id===init})[0];
    if(iv&&hasUni){
      var p0=packs.filter(function(p){return p.getAttribute('data-pack')===iv.o1})[0];
      if(p0){for(var f=iv.n;f>=0;f--){if(uniLabel(iv.n,f,A,B)===iv.o2){slotsOf(p0).forEach(function(s,i){setSlot(s,i<f?'a':'b')});break;}}}
    }
    // Lien avec ?variant= (pub) : la galerie s'ouvre directement sur la photo de la variante,
    // puis s'y recale une fois les images chargées. Sans ?variant=, elle reste sur la photo principale.
    if(/[?&]variant=/.test(location.search)){
      update('now');
      window.addEventListener('load',function(){if(current&&current.m)slides.forEach(function(s,i){if(+s.getAttribute('data-media')===current.m)go(i,true)});mark();});
    } else update(false);

    form.addEventListener('submit',function(e){
      e.preventDefault();var btn=$('[data-av-atc]',form),msg=$('[data-av-msg]',form);msg.textContent='';
      if(!current||!current.a){msg.textContent=form.getAttribute('data-unavailable');return;}
      btn.disabled=true;
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:current.id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw 0;return r.json()})
        .then(function(){location.href=root+'cart';})
        .catch(function(){btn.disabled=false;msg.textContent=form.getAttribute('data-error');});
    });
  }

  // Date limite réelle : texte normal jusqu'à la date, puis texte de remplacement
  function deadline(){
    $$('[data-av-deadline]').forEach(function(d){
      var until=d.getAttribute('data-until');if(!until)return;
      var end=new Date(until+'T23:59:59');
      if(!isNaN(end)&&new Date()>end){var late=d.getAttribute('data-late');if(late)$('[data-av-deadline-text]',d).textContent=late;else d.hidden=true;}
    });
  }

  // Frise de livraison : jours ouvrables (lundi-vendredi)
  function addBiz(date,n){var d=new Date(date);while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d;}
  function fmt(d){try{return d.toLocaleDateString('fr-CH',{weekday:'short',day:'numeric',month:'short'})}catch(e){return d.getDate()+'.'+(d.getMonth()+1)}}
  function timeline(){
    $$('[data-av-ship]').forEach(function(s){
      var now=new Date(), ship=+s.getAttribute('data-ship'), mn=+s.getAttribute('data-min'), mx=Math.max(mn,+s.getAttribute('data-max'));
      $('[data-av-d1]',s).textContent=fmt(now);
      $('[data-av-d2]',s).textContent=fmt(addBiz(now,ship));
      $('[data-av-d3]',s).textContent=fmt(addBiz(now,mn))+' – '+fmt(addBiz(now,mx));
    });
  }

  // Liens « Choisir mon offre » : défilement vers les packs
  function anchors(){
    $$('[data-av-scroll]').forEach(function(a){a.addEventListener('click',function(e){var t=$('[data-av-form]');if(!t)return;e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'center'});});});
  }

  function init(){
    $$('[data-av-product]').forEach(function(el){try{product(el)}catch(err){console.error('hm-av',err)}});
    try{deadline();timeline();anchors()}catch(err){console.error('hm-av',err)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
